<template>
  <button :disabled="!isEnabled" @click="$emit('click', $event)">
    {{ text }}
  </button>
</template>

<script>

export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    isEnabled: {
      type: Boolean,
      default: true
    }
  }
}

</script>